import { z } from 'zod';
import { userRepResDto } from '../keycloak/user-rep.res.dto';

export const participantResponsibleUserResDto = z.object({
  responsibleUser: userRepResDto.nullable(),
});
export type ParticipantResponsibleUserResDto = z.infer<
  typeof participantResponsibleUserResDto
>;
